// Import bloków
import "./js/button";
import "./js/excerpt";
import "./js/group";
import "./js/image";
import "./js/search";
import "./js/slider";
import "./js/video";
import "./js/postImage";
import "./js/menu";
import "./js/modal";
import "./js/customIcon";
import "./js/heading";
import "./js/column";
import "./js/spacing";
import "./js/map";
import "./js/contactForm";
import "./js/bar";
import "./js/details";
import "./js/pageSettings";
import "./js/FeaturedImageUrl";
import "./js/table";
import "./js/responsiveImage";
import "./js/cover";

import { addFilter } from "@wordpress/hooks";
import withVisibilityControls from "./js/hoc/withVisibilityControls";
import withDimensionsControls from "./js/hoc/withDimensionsControls";

// Lista bloków z kontrolkami
const blocksWithVisibility = [
    "core/group",
    "core/paragraph",
    "core/heading",
    "core/column",
];
const blocksWithDimensions = [
    "core/group",
    "core/cover",
    "core/image",
    "core/column",
];

// Najpierw dodajemy atrybuty
addFilter(
    "blocks.registerBlockType",
    "danone/add-dimensions-attributes",
    (settings, name) => {
        if (!blocksWithDimensions.includes(name)) {
            return settings;
        }

        return {
            ...settings,
            attributes: {
                ...settings.attributes,
                widthDesktop: {
                    type: "object",
                    default: {},
                },
                widthTablet: {
                    type: "object",
                    default: {},
                },
                widthMobile: {
                    type: "object",
                    default: {},
                },
                heightDesktop: {
                    type: "object",
                    default: {},
                },
                heightTablet: {
                    type: "object",
                    default: {},
                },
                heightMobile: {
                    type: "object",
                    default: {},
                },
            },
        };
    }
);

addFilter(
    "blocks.registerBlockType",
    "danone/add-visibility-attribute",
    (settings, name) => {
        if (!blocksWithVisibility.includes(name)) {
            return settings;
        }

        return {
            ...settings,
            attributes: {
                ...settings.attributes,
                hideBreakpoint: {
                    type: "object",
                    default: {
                        desktop: false,
                        tablet: false,
                        phone: false,
                    },
                },
            },
        };
    }
);

// Dodajemy kontrolki w odwrotnej kolejności
addFilter(
    "editor.BlockEdit",
    "danone/with-visibility-controls",
    withVisibilityControls
);

addFilter(
    "editor.BlockEdit",
    "danone/with-dimensions-controls",
    withDimensionsControls
);

// Dodaj nowy filtr dla zapisywania stylów wymiarów
addFilter(
    "blocks.getSaveContent.extraProps",
    "danone/save-dimensions-styles",
    (extraProps, blockType, attributes) => {
        2;
        if (!blocksWithDimensions.includes(blockType.name)) {
            return extraProps;
        }

        // Inicjalizuj style jeśli nie istnieją
        if (!extraProps.style) {
            extraProps.style = {};
        }

        // Dodaj style dla wymiarów
        if (attributes.widthDesktop?.value) {
            extraProps.style["--width-desktop"] = `${
                attributes.widthDesktop.value
            }${attributes.widthDesktop.valueUnit || "px"}`;
        }
        if (attributes.heightDesktop?.value) {
            extraProps.style["--height-desktop"] = `${
                attributes.heightDesktop.value
            }${attributes.heightDesktop.valueUnit || "px"}`;
        }
        if (attributes.widthTablet?.value) {
            extraProps.style["--width-tablet"] = `${
                attributes.widthTablet.value
            }${attributes.widthTablet.valueUnit || "px"}`;
        }
        if (attributes.heightTablet?.value) {
            extraProps.style["--height-tablet"] = `${
                attributes.heightTablet.value
            }${attributes.heightTablet.valueUnit || "px"}`;
        }
        if (attributes.widthMobile?.value) {
            extraProps.style["--width-mobile"] = `${
                attributes.widthMobile.value
            }${attributes.widthMobile.valueUnit || "px"}`;
        }
        if (attributes.heightMobile?.value) {
            extraProps.style["--height-mobile"] = `${
                attributes.heightMobile.value
            }${attributes.heightMobile.valueUnit || "px"}`;
        }

        // Dodaj klasę dla stylów
        if (
            attributes.widthDesktop?.value ||
            attributes.heightDesktop?.value ||
            attributes.widthTablet?.value ||
            attributes.heightTablet?.value ||
            attributes.widthMobile?.value ||
            attributes.heightMobile?.value
        ) {
            extraProps.className = extraProps.className
                ? `${extraProps.className} has-custom-dimensions`
                : "has-custom-dimensions";
        }

        return extraProps;
    }
);
